import State from "@/helpers/pattern/state";
import { Acuerdo } from "@/models/operativos/acuerdo";
import { modelIsModified } from "@/helpers/vue-mc";
import acuerdoAPI from "@/services/operativos/acuerdo";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { clearSwal } from "@/constants/sweet-alerts";
import { scrollToForm } from "@/helpers/form-scroll-to";

/**
 * State Pattern for acuerdo form
 */
export default class AcuerdoStates extends State {
  /**
   * General Methods
   */
  base() {
    return {
      clear({ $setState }) {
        $setState("initial");
      }
      , async askForClear({ $data }) {
        try {
          if ((await $data.$swal(clearSwal)).value) this.clear();
        } catch (error) {
          console.error(error);
        }
      }
      , resetModel({ $data }) {
        $data.acuerdo = new Acuerdo();
      }
      , resetValidators({ $data }) {
        $data.$v.$reset();
      }
      , isDisableButtonSubmit({ $data }) {
        return $data.hasErrors($data.$v.acuerdo) || $data.view.action.submit.busy || !modelIsModified($data.acuerdo);
      }
    };
  }

  /**
   * States and their methods
   */
  states() {
    return {
      initial: {
        $constructor: function ({ $data }) {
          // Reset Models and validators
          this.resetModel();
          this.resetValidators();
          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.save;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.save;
        }
        , async submit({ $data }, { descripcion, status }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }

            $data.view.action.submit.busy = true;

            const response = await acuerdoAPI.save({
              clave: null
              , descripcion
              , status
            });

            $data.view.action.submit.busy = false;
            this.resetModel();
            this.resetValidators();
            $data.$refs.acuerdoTable.refreshData();
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
      , editing: {
        $constructor: function ({ $data }, { clave, descripcion, status }) {
          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.update;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.update;

          $data.acuerdo = new Acuerdo({
            clave
            , descripcion
            , status
          });

          this.resetValidators();
          scrollToForm($data);
        }
        , async submit({ $data, $setState }, { clave, descripcion, status }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }
            $data.view.action.submit.busy = true;

            const response = await acuerdoAPI.update({
              clave
              , descripcion
              , status
            });

            $data.$refs.acuerdoTable.refreshData();
            $data.view.action.submit.busy = false;
            $setState("initial");
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/views/operativos/acuerdo/acuerdo-state.js